import React from "react";
import { Box, TextField, Typography, alpha } from "@mui/material";
import { fieldProps } from "./RegistrationFields";

const PromotionCodeField = ({ formik, disabled }) => (
  <Box
    component='section'
    aria-labelledby='register-promotion-title'
    sx={{
      p: 2,
      border: 1,
      borderColor: "divider",
      borderRadius: 2,
      bgcolor: (theme) => alpha(theme.palette.primary.main, 0.025),
    }}
  >
    <Typography
      id='register-promotion-title'
      component='h2'
      variant='subtitle2'
      fontWeight={700}
      sx={{ mb: 1.5 }}
    >
      Have a promotion code?
    </Typography>
    <TextField
      {...fieldProps(formik, "promoCode")}
      label='Promotion code (optional)'
      disabled={disabled}
      autoComplete='off'
      inputProps={{ autoCapitalize: "none", spellCheck: false }}
      helperText={
        (formik.touched.promoCode && formik.errors.promoCode) ||
        "Received a code from a partner website? Enter it here. Any offer is subject to the code's terms and eligibility."
      }
    />
  </Box>
);

export default PromotionCodeField;
